import {axiosPrivate} from '../interceptors';
import getBaseURL from './getBaseURL';

const baseURl = getBaseURL();

export const getVersion = () => {
  const url = `${baseURl}/app-info/version`;
  return axiosPrivate.request({url: url, method: 'GET'});
};
